import React from 'react'
import { useHistory } from 'react-router-dom'

import { customFolder } from '../../../../../../constants/constants'
import { RoutePath } from '../../../../../../router/routesConfig'

import useLookupService from '../../../../../../services/lookup/useLookupService'
import useWebService from '../../../../../../services/web/useWebService'
import useLoading from '../../../../../../control/loading/useLoading'
import useManageProjectAction from '../../../../../../stores/manageProject/useManageProjectAction'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'

import useTranslate from '../../../../../../i18n/useTranslate'
import checkPermission from '../../../../../../utilities/checkPermission'

import * as submittedWithdrawType from './submittedWithdrawType'
import { DialogType } from '../../../../../../control/dialog/dialog'
import constSubmittedType from '../../../../../../constants/submittedType'
import * as REQServiceTypes from '../../../../../../services/web/types/requestWebServiceTypes'
import * as RESServiceTypes from '../../../../../../services/web/types/responseWebServiceTypes'
import { responseWebServiceTypes } from '../../../../../../services/web/types'
import submittedType from '../../../../../../constants/submittedType'
import { checkAllAdditionalDocTopicsHavePdf, withFileTokenInfo } from '../../../../../../utilities/additionalDoc'

const useSubmittedWithdraw = () => {
    const [initialValues, setInitialValues] = React.useState<any>({})
    const [initialUploadFile, setInitialUploadFile] = React.useState<any>()
    const [_, setProjectPageData] = React.useState<RESServiceTypes.GetProjectWithdrawResponse>()
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()

    const parameterForSaveRef = React.useRef<REQServiceTypes.SaveProjectWithdrawType>()
    const dialogRef = React.useRef<Record<string, Function>>()

    const loadingHook = useLoading()
    const callLookup = useLookupService()
    const callWebService = useWebService()
    const history = useHistory()
    const translate = useTranslate()
    const checkPermissionHook = checkPermission()
    const folderAndTabStore = useFolderAndTabStore()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const manageProjectAction = useManageProjectAction()
    const manageProjectStore = useManageProjectStore()
    const { folderSelected } = folderAndTabStore
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(manageProjectStore.projectData)

    React.useEffect(() => {
        if (manageProjectStore.projectData) {
            loadProjectPageData()
        }
    }, [manageProjectStore.projectData?.submittedID])

    const getDocumentTopicLut = async (irb: number, submitTypeID: number) => {
        const res = await callLookup.callDocumentTopicLut(irb, submitTypeID)
        if (res.status === 1) {
            return res.result
        } else {
            return []
        }
    }

    const checkRequirePDF = (documentInfo: Array<REQServiceTypes.DocumentInfo>) => {
        let isRequirePDF = false

        for (let i = 0; i < documentInfo?.length; i++) {
            if (!isRequirePDF) {
                for (let j = 0; j < documentInfo[i]?.fileTokenInfo.length; j++) {
                    if ((documentInfo[i]?.fileTokenInfo[j] as any)?.fileExtension === 'pdf') {
                        isRequirePDF = false
                        break
                    } else {
                        isRequirePDF = true
                    }
                }
            }
        }
        return isRequirePDF
    }

    const loadProjectPageData = async () => {
        if (manageProjectStore.projectData?.submittedID) {
            initialProcessUpdate()
        } else {
            initialProcessCreate()
        }
    }

    const initialProcessCreate = () => {
        createInitialData()
        initialUpload()
    }

    const initialProcessUpdate = async () => {
        if (manageProjectStore.projectData?.submittedID) {
            const res = await callWebService.getProjectWithdraw(manageProjectStore.projectData.submittedID)

            if (res.status === 1) {
                setProjectPageData(res.result)

                createInitialData(res.result)
                initialUpload(res.result.documentInfo)
            } else {
                setProjectPageData(undefined)
            }
        }
    }

    const createInitialData = (initVal?: responseWebServiceTypes.GetProjectWithdrawResponse) => {
        const initialData: Record<string, any> = {
            withdrawCause: null,
            documentAdditionalInfo: [],
        }
        if (initVal) {
            initialData.withdrawCause = initVal.reason
            initialData.documentAdditionalInfo = initVal.documentAdditionalInfo ?? []
        }

        setInitialValues(initialData)
    }

    const initialUpload = async (
        initDocumentInfo?: responseWebServiceTypes.GetProjectWithdrawResponse['documentInfo'],
    ) => {
        if (manageProjectStore.projectData?.irb) {
            const lstDocumentTopic = await getDocumentTopicLut(
                manageProjectStore.projectData?.irb,
                constSubmittedType.withdrawalSubmitted,
            )
            manageProjectAction.setDocumentTopic(lstDocumentTopic)

            let uploadFileInit = lstDocumentTopic?.map((itm: any, idx: number) => {
                return {
                    uploadFileObj: {
                        fileList: [],
                        subTopicPageList: [],
                        documentTopicID: itm.id,
                        isDisplay: itm.isDisplay,
                        isRequired: itm.isRequired,
                    },
                }
            }) as Array<submittedWithdrawType.UploadFileObjType>

            if (folderSelected.id !== customFolder.withdrawSubmitted.id) {
                uploadFileInit?.forEach((itm: submittedWithdrawType.UploadFileObjType) => {
                    initDocumentInfo?.forEach((docInfo) => {
                        if (docInfo.topicID === itm.uploadFileObj.documentTopicID) {
                            if (docInfo.fileInfo?.length > 0) {
                                //@ts-ignore
                                itm.uploadFileObj.fileList.push({
                                    ...docInfo.fileInfo[0],
                                    fileID: docInfo.fileInfo[0].fileID,
                                    documentTopicID: docInfo.fileInfo[0].topicID as number,
                                    fileToken: docInfo.fileInfo[0].fileToken, //fileToken
                                    filename: docInfo.fileInfo[0].filename,
                                    path: docInfo.fileInfo[0].path,
                                    replaceFileID: docInfo.fileInfo[0].replaceFileID,
                                })
                            }

                            if (docInfo?.subtopic?.length > 0) {
                                //@ts-ignore
                                itm.uploadFileObj.subTopicPageList = docInfo.subtopic[0]
                            }
                        }
                    })
                })
            }

            //Filter การซ่อนแสดงหัวข้อเอกสาร ถ้าฝั่งสำนักงานให้ซ่อนหัวข้อเอกสาร แต่ว่าหัวข้อนั้นมีไฟล์อยู่ให้ทำการแสดงหัวข้อนั้นออกมา
            if (uploadFileInit?.length > 0) {
                uploadFileInit = uploadFileInit.filter((itm: any) => {
                    return itm.uploadFileObj.isDisplay || itm.uploadFileObj.fileList.length !== 0
                })
            }
            setInitialUploadFile(uploadFileInit)
        }
    }

    const getDocumentInfoForSave = (val: any) => {
        let fileDataList = val.uploadFile.filter((itm: any) => itm.uploadFileObj.fileList.length > 0)
        let myFileData: Array<REQServiceTypes.DocumentInfo> = []

        fileDataList.forEach((uploadObj: submittedWithdrawType.UploadFileObjType) => {
            const subTopicLst = uploadObj?.uploadFileObj.subTopicPageList?.map((subtopic) => {
                return {
                    subtopicID: subtopic.subtopicID,
                    page: subtopic.page,
                }
            })

            const fileTokenInfo: Array<{
                replaceFileID: number
                fileToken: string
                fileExtension?: string
                fileID: any
            }> =
                uploadObj.uploadFileObj.fileList?.map((file) => {
                    return {
                        //@ts-ignore
                        replaceFileID: file?.replaceFileID ? file.replaceFileID : null,
                        fileToken: file.fileToken,
                        fileExtension: file.filename.split('.').pop(),
                        fileID: file?.fileID ? file.fileID : null,
                    }
                }) ?? []

            myFileData.push({
                documentTopicID: uploadObj?.uploadFileObj?.documentTopicID,
                fileTokenInfo: fileTokenInfo,
                subtopic: subTopicLst && subTopicLst.length > 0 ? subTopicLst : [],
            })
        })

        return myFileData
    }
    const loadLatestFolder = async () => {
        try {
            loadingHook.loadingOpen()
            const currentProjectID = manageProjectStore.projectData?.projectID

            if (currentProjectID) {
                const resProjectFolder = await callWebService.getProjectFolder(currentProjectID)

                const projectFolder = resProjectFolder.result?.folders?.map((itm: any, index: number) => {
                    return {
                        ...itm,
                        id: itm.submittedID,
                        isLastProcess: index === 0 ? true : false,
                    }
                })
                if (
                    projectFolder?.length > 0 &&
                    projectFolder[0]?.submittedTypeID === submittedType.withdrawalSubmitted
                ) {
                    loadingHook.loadingClose()
                    appFolderAndTabAction.setState({
                        folderList: projectFolder,
                        folderSelected: projectFolder[0],
                    })
                }
                if (
                    projectFolder?.length > 0 &&
                    projectFolder[0]?.submittedTypeID === submittedType.withdrawalSubmitted
                ) {
                    loadingHook.loadingClose()
                    const selectedFolder = projectFolder[0]
                    const resProject = await callWebService.getProjectByID(currentProjectID, selectedFolder.submittedID)
                    if (resProject.result) {
                        manageProjectAction.setProjectData(resProject.result)
                    }
                }
            }
        } catch (ex) {
        } finally {
            loadingHook.loadingClose()
        }
    }
    const onConfirmSave = async () => {
        if (parameterForSaveRef.current) {
            loadingHook.loadingOpen()
            let res = await callWebService.saveProjectWithdraw(parameterForSaveRef.current)

            if (res.status === 1) {
                loadingHook.loadingClose()
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                    type: 'alert-message',
                    onAfterClose: loadLatestFolder,
                })
                dialogRef.current?.openDialog()
            } else {
                loadingHook.loadingClose()
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.ERROR'),
                    content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                    type: 'alert-message',
                })
                dialogRef.current?.openDialog()
            }
        }
    }
    const validateRequiredUploadFile = (uploadFile: Array<{ uploadFileObj: any }>, skipValidate: boolean = false) => {
        let isValid = true
        if (!skipValidate) {
            uploadFile?.every(({ uploadFileObj: file }) => {
                if (file?.isRequired && file?.fileList?.length === 0) {
                    //เป็นหัวข้อที่มีการ required แต่ว่าไม่ upload เอกสาร
                    isValid = false
                    return false //break
                }
                return true //continue
            })

            if (!isValid) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get2Element('ALERT.CONTENT.PLEASE_UPLOAD_REQUIRED_TOPIC', [
                        '<label style="color: red;">*</label>',
                    ]) as any,
                    type: 'alert-message',
                })
                dialogRef.current?.openDialog()
            }
        }
        return isValid
    }
    const onSubmit = (values: any) => {
        const loginType = localStorage.getItem('loginType')
        const isSubmitByAdmin = loginType === '2' ? true : false
        const projectID = manageProjectStore.projectData?.projectID ?? null
        let submittedID: number | null = folderSelected.submittedID
        if (folderSelected.submittedID === customFolder.withdrawSubmitted.submittedID) {
            submittedID = null
        }
        parameterForSaveRef.current = {
            projectID: projectID,
            submittedID: submittedID,
            reason: values.withdrawCause,
            isWithdrawProject: false, //ถอนการยื่น (Submitted)
            documentInfo: getDocumentInfoForSave(values),
            isSubmitByAdmin: isSubmitByAdmin,
            documentAdditionalInfo: withFileTokenInfo(values.documentAdditionalInfo),
        }

        const skipCheckRequiredUploadFile = isSubmitByAdmin
        if (validateRequiredUploadFile(values.uploadFile, skipCheckRequiredUploadFile)) {
            const countUploadFile = parameterForSaveRef.current?.documentInfo?.length ?? 0
            const isRequirePDF = checkRequirePDF(parameterForSaveRef.current.documentInfo)
            const allAdditionalDocTopicsHavePdf = checkAllAdditionalDocTopicsHavePdf(
                parameterForSaveRef.current?.documentAdditionalInfo,
            )

            const isEmptyPage = checkSubtopic(parameterForSaveRef.current?.documentInfo)
            if (countUploadFile > 0 && (isRequirePDF || !allAdditionalDocTopicsHavePdf)) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.UPLOAD_PDF_AT_LEAST_1_FILE'),
                    type: 'alert-message',
                })
            } else if (isEmptyPage) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.PLEASE_COMPLETE_PAGE'),
                    type: 'alert-message',
                })
            } else {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                    type: 'alert-confirm',
                    onClickConfirm: onConfirmSave,
                })
            }

            dialogRef.current?.openDialog()
        }
    }

    const checkSubtopic = (documentInfo: Array<REQServiceTypes.DocumentInfo>) => {
        let isEmptyPage = false

        //หาว่าหัวข้ออัปโหลดเอกสารมีให้อัปโหลดหัวข้อย่อยมั้ย
        const docTopic = manageProjectStore.documentTopic?.filter((item) => item.subtopic.length > 0)

        //ถ้ามีให้เข้าไปเช็คตามเงื่อนไข if
        if (docTopic?.length) {
            // วน loop หัวข้อที่มีให้อัปโหลดเอกสารหัวข้อย่อย
            docTopic.forEach((mainTopic) => {
                // วน loop หัวข้อที่มีการอัปโหลดเอกสารเข้ามา
                documentInfo.forEach((itm) => {
                    // เช็คว่าเอกสารที่มีการอัปโหลดเข้ามาใช่เอกสารที่มีหัวข้อย่อยให้อัปโหลดหรือป่าว
                    if (mainTopic.id === itm.documentTopicID) {
                        // เช็คว่าหัวข้อย่อยที่อัพโหลดเข้ามาครบมั้ย
                        if (itm.subtopic?.length != mainTopic.subtopic.length) {
                            isEmptyPage = true
                        } else {
                            // เช็คว่าที่อัปมาครบมีช่องไหนกรอกเป็น ช่องว่างมั้ย
                            const chkEmpty = itm.subtopic.find(
                                (e) => e.page == null || e.page == '' || e.page == undefined,
                            )
                            if (chkEmpty) {
                                isEmptyPage = true
                            }
                        }
                    }
                })
            })
        }

        return isEmptyPage
    }
    const onClickCancel = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',

                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }
    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }
    const onDirtyChange = (formState: Record<string, any>) => {
        // appFolderAndTabAction.setTabDirty(formState.dirty)
    }

    const conditionHideUploadSection = () => {
        let isHide = false
        const isUserResearcher = checkPermissionHook.isUserResearcher()

        if (isUserResearcher) {
            // isHide = manageProjectStore.projectData?.isSubmitByAdmin ?? false
            // ถ้า required ตลอดก็ผ่านตลอด
            isHide = false
        }
        return isHide
    }

    return {
        initialVal: {
            ...initialValues,
            uploadFile: initialUploadFile,
            documentAdditionalInfo: manageProjectStore.projectData?.documentAdditionalInfo,
        },
        initialUploadFile,
        uploadDocumentTopic: manageProjectStore.documentTopic,
        projectData: manageProjectStore.projectData,
        isViewMode: isViewMode,
        isHideUploadSection: conditionHideUploadSection(),
        configDialog,
        onClickCancel,
        onSubmit,
        onRefDialog,
        onDirtyChange,
    }
}
export default useSubmittedWithdraw
